// The route import schema object defines the component import scheme for all
// the routes in the application. This information can then be used to extend
// the route metadata (by an operation inside the route manager, defined in
// `/routes/index.js` ) that asserts the actual order in which the routes are
// read by the routing component.
export default {
  base: {
    load: () => import(/* webpackChunkName: 'base' */ './base'),
  },
  '/dashboard': {
    load: false,
    children: [
      {
        path: '',
        load: () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
      },
      {
        path: '/:queryName',
        load: () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
      },
    ],
  },
  '/applications': {
    children: [
      {
        path: '',
        load: () =>
          import(/* webpackChunkName: 'applications' */ './applications'),
      },
      {
        path: '/:appId',
        load: () =>
          import(/* webpackChunkName: 'applications' */ './applications'),
      },
      {
        path: '/:appId/versions/:versionId/:tab?',
        load: () =>
          import(/* webpackChunkName: 'applications' */ './applications'),
      },
    ],
  },
  '/artifacts/image': {
    children: [
      {
        path: '',
        load: () => import(/* webpackChunkName: 'artifacts' */ './artifacts'),
      },
      {
        path: '/:registry',
        load: () => import(/* webpackChunkName: 'artifacts' */ './artifacts'),
      },
      {
        path: '/:registry/:repository',
        load: () => import(/* webpackChunkName: 'artifacts' */ './artifacts'),
      },
      {
        path: '/:registry/:repository/:tag',
        load: () => import(/* webpackChunkName: 'artifacts' */ './artifacts'),
      },
      {
        path: '/:registry/:repository/:tag/:id',
        load: () => import(/* webpackChunkName: 'artifacts' */ './artifacts'),
      },
    ],
  },
  '/policy': {
    children: [
      {
        path: '',
        load: () => import(/* webpackChunkName: 'policy' */ './policy'),
      },
      {
        path: '/:policyId',
        load: () => import(/* webpackChunkName: 'policy' */ './policy'),
      },
    ],
  },
  '/search': {
    children: [
      {
        path: '',
        load: () => import(/* webpackChunkName: 'search' */ './search'),
      },
      {
        path: '/vulnerabilities/:vulnerabilityId',
        load: () => import(/* webpackChunkName: 'search' */ './search'),
        title: 'Vulnerability Search',
      },
    ],
  },
  '/inventory': {
    load: () => import(/* webpackChunkName: 'base' */ './base'),
  },
  '/inventory/kubernetes': {
    children: [
      {
        path: '',
        load: () => import(/* webpackChunkName: 'inventory' */ './inventory'),
      },
      {
        path: '/:cluster',
        load: () => import(/* webpackChunkName: 'inventory' */ './inventory'),
      },
      {
        path: '/:cluster/:namespace',
        load: () => import(/* webpackChunkName: 'inventory' */ './inventory'),
      },
    ],
  },
  '/reports': {
    children: [
      {
        path: '',
        load: () => import(/* webpackChunkName: 'reports' */ './reports'),
      },
      {
        path: '/saved',
        load: () => import(/* webpackChunkName: 'reports' */ './reports'),
      },
      {
        path: '/new',
        load: () => import(/* webpackChunkName: 'reports' */ './reports'),
      },
      {
        path: '/templates',
        load: () => import(/* webpackChunkName: 'reports' */ './reports'),
      },
      {
        path: '/saved/:reportId/result/:executionId',
        load: () => import(/* webpackChunkName: 'reports' */ './reports'),
      },
    ],
  },
  '/events': {
    children: [
      {
        path: '',
        load: () => import(/* webpackChunkName: 'events' */ './events'),
      },
    ],
  },
  '/notifications': {
    children: [
      {
        path: '',
        load: () => import(/* webpackChunkName: 'events' */ './events'),
      },
    ],
  },
  '/system': {
    children: [
      {
        path: '',
        load: () => import(/* webpackChunkName: 'system' */ './system'),
      },
      {
        path: '/:tab',
        load: () => import(/* webpackChunkName: 'system' */ './system'),
      },
      {
        path: '/accounts/:accountName',
        load: () => import(/* webpackChunkName: 'system' */ './system'),
      },
    ],
  },
  '(.*)': {
    load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
  },
};
